import React from "react";
import CustomTextField from "../../../common/InputField/Input";
import { useSelector } from "react-redux";
import UploadFile from "./UploadId";
import { Input, message } from "antd";
import { isFileSizeValid } from "../../utils";
import { uploadFiles } from "../../../../services/scanUpload";
import PhotosSection from "./PhotosSection";
import beImagePlaceHolder from "../../../../assets/images/svgs/beImagePlaceHolder.svg";
import { FiEye } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import Preview from "./Preview";
import { TranslateText } from "../../../../utils/translation";
import { IoCloseSharp } from "react-icons/io5";

const BEHotelDetails = ({
  localHotelDetailsState,
  setLocalHotelDetailsState,
  subdomainSuggestions = [],
  subdomainAvailabilityMessage = "",
  onSubdomainSuggestionSelect,
  onSubdomainInputChange,
}) => {
  const { TextArea } = Input;

  const { editHotelDetails } = useSelector((store) => store.usersRestriction);

  const handleImageBeforeUpload = async (file, fileSize) => {
    const fileSizeInKb = fileSize * 1000;

    if (
      !isFileSizeValid(
        file,
        fileSize,
        `File size must be smaller than ${fileSizeInKb} kb`
      )
    ) {
      message.error(`File size must be lesser than ${fileSizeInKb} kb`);
      return false;
    } else return true;
  };

  const handleUpload = async (item, title) => {
    const file = item.file;
    const data = new FormData();
    data.append("file", file);

    let uploadedFile = await uploadFiles(data);

    if (uploadedFile !== null) {
      setLocalHotelDetailsState({
        ...localHotelDetailsState,
        [title]: uploadedFile, // Using computed property name for dynamic key
      });
      const capitalizeFirstLetter = (str) => {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      };

      message.success(`${capitalizeFirstLetter(title)} uploaded `);
    }
  };

  const handlePhotoSectionImageUpload = async (item, title) => {
    const file = item.file;
    const data = new FormData();
    data.append("file", file);

    let uploadedFile = await uploadFiles(data);

    if (uploadedFile !== null) {
      const updatedLocalState = {
        ...localHotelDetailsState,
        images: [
          ...(Array.isArray(localHotelDetailsState?.images)
            ? localHotelDetailsState.images
            : []),
          { type: title, url: uploadedFile }, // use uploadedFile instead of uploadFiles
        ],
      };

      setLocalHotelDetailsState(updatedLocalState);

      const capitalizeFirstLetter = (str) => {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      };

      message.success(`${capitalizeFirstLetter(title)} uploaded `);
    }
  };

  const removeImage = (url) => {
    const currentImageArray = [
      ...(Array.isArray(localHotelDetailsState?.images)
        ? localHotelDetailsState.images
        : []),
    ]?.filter((Obj) => Obj?.url !== url);

    setLocalHotelDetailsState({
      ...localHotelDetailsState,
      images: currentImageArray,
    });
  };

  const isCertificateUploaded = Boolean(
    localHotelDetailsState?.images?.filter(
      (Obj) => Obj?.type === "certificate"
    )?.[0]
  );

  return (
    <div className="mb-[10rem]">
      <header className="w-[100%] flex justify-between items-center">
        <div className="font-body font-[500] text-[24px] leading-[30.34px] text-fg ">
          <TranslateText textKey={"basic_information"} namespace="profile" />
        </div>
      </header>

      <main className="flex w-[100%] justify-between gap-[34px] items-start mt-[34px]">
        <div className="leftPart flex flex-col gap-[20px] w-[75%]">
          <CustomTextField
            label="Hotel name &nbsp;"
            isManadatory={true}
            value={localHotelDetailsState?.name}
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                name: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="6px"
            labelFontSize="14px"
            labelTextColor="rgb(var(--color-text-placeholder))"
            inputTextColor="rgb(var(--color-text-primary))"
            inputTextFontSize="1rem"
            labelTracking="0.5px"
            inputHeight="50px"
          />

          <div className="w-full">
            <div className="font-body text-[14px] text-fg-placeholder mb-[6px]">
              Booking engine subdomain
            </div>

            <div className="w-full h-[50px] border border-brand-border rounded-[8px] overflow-hidden flex items-stretch bg-surface">
              <Input
                value={localHotelDetailsState?.bookingEngineSubdomain || ""}
                placeholder="your-hotel"
                bordered={false}
                onChange={(e) => {
                  const normalizedSubdomain = e.target.value
                    ?.toString()
                    ?.trim()
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "-")
                    ?.replace(/[^a-z0-9-]/g, "")
                    ?.replace(/-+/g, "-")
                    ?.replace(/^-+|-+$/g, "");

                  setLocalHotelDetailsState({
                    ...localHotelDetailsState,
                    bookingEngineSubdomain: normalizedSubdomain,
                  });
                  onSubdomainInputChange?.(normalizedSubdomain);
                }}
                className="h-full px-[10px] flex-1"
              />
              <div className="min-w-[250px] max-w-[300px] px-[14px] border-l border-brand-border bg-neutral-50 text-fg font-body text-[16px] flex items-center">
                .sites.revivotech.in
              </div>
            </div>

            <div className="font-body text-[12px] text-fg-placeholder mt-[6px]">
              Only lowercase letters, numbers and hyphen are allowed.
            </div>

            {Boolean(subdomainAvailabilityMessage) && (
              <div className="font-body text-[12px] text-primary mt-[6px]">
                {subdomainAvailabilityMessage}
              </div>
            )}

            {Array.isArray(subdomainSuggestions) &&
              subdomainSuggestions.length > 0 && (
                <div className="flex flex-wrap gap-[8px] mt-[8px]">
                  {subdomainSuggestions.map((suggestion) => (
                    <button
                      type="button"
                      key={suggestion}
                      className="px-[10px] py-[6px] rounded-[999px] border border-primary-light bg-primary-light text-primary font-body text-[12px] hover:bg-primary-light"
                      onClick={() => onSubdomainSuggestionSelect?.(suggestion)}
                    >
                      {suggestion}.sites.revivotech.in
                    </button>
                  ))}
                </div>
              )}
          </div>
          <CustomTextField
            label="Hotel address &nbsp;"
            isManadatory={true}
            value={localHotelDetailsState?.address}
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                address: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="6px"
            labelFontSize="14px"
            labelTextColor="rgb(var(--color-text-placeholder))"
            inputTextColor="rgb(var(--color-text-primary))"
            inputTextFontSize="1rem"
            labelTracking="0.5px"
          />{" "}
          <CustomTextField
            label="Hotel contact &nbsp;"
            isManadatory={true}
            value={localHotelDetailsState?.contactNumber}
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                contactNumber: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="6px"
            labelFontSize="14px"
            labelTextColor="rgb(var(--color-text-placeholder))"
            inputTextColor="rgb(var(--color-text-primary))"
            inputTextFontSize="1rem"
            labelTracking="0.5px"
          />{" "}
          <CustomTextField
            label="Alternate contact &nbsp;"
            isManadatory={false}
            value={
              Array.isArray(localHotelDetailsState?.contactNumbers)
                ? localHotelDetailsState?.contactNumbers?.[0]
                : ""
            }
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                contactNumbers: [value],
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="6px"
            labelFontSize="14px"
            labelTextColor="rgb(var(--color-text-placeholder))"
            inputTextColor="rgb(var(--color-text-primary))"
            inputTextFontSize="1rem"
            labelTracking="0.5px"
          />{" "}
          <CustomTextField
            label="Hotel email &nbsp;"
            isManadatory={true}
            value={localHotelDetailsState?.emailAddress}
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                emailAddress: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="6px"
            labelFontSize="14px"
            labelTextColor="rgb(var(--color-text-placeholder))"
            inputTextColor="rgb(var(--color-text-primary))"
            inputTextFontSize="1rem"
            labelTracking="0.5px"
          />
          <CustomTextField
            label="Google Maps link &nbsp;"
            isManadatory={false}
            value={localHotelDetailsState?.googleMapsLink}
            onChange={(value) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                googleMapsLink: value,
              })
            }
            type="text"
            inputPadding={true}
            inputPaddingValue="6px"
            labelFontSize="14px"
            labelTextColor="rgb(var(--color-text-placeholder))"
            inputTextColor="rgb(var(--color-text-primary))"
            inputTextFontSize="1rem"
            labelTracking="0.5px"
          />
          <TextArea
            className="rounded-[8px] p-3 text-fg border-neutral-300 
            hover:border-fg-muted font-body text-[16px] font-[400] pl-[1.3rem] leading-[20px]"
            placeholder="About your hotel"
            value={localHotelDetailsState?.aboutUs}
            onChange={(e) =>
              setLocalHotelDetailsState({
                ...localHotelDetailsState,
                aboutUs: e.target.value,
              })
            }
            autoSize={{
              minRows: 4,
              maxRows: 6,
            }}
          />
        </div>

        <div className="rightPart w-[190px] flex flex-col gap-[24px] items-start justify-start ">
          <div className="font-body font-[500] text-[18px] leading-[22.68px] text-fg">
            <TranslateText textKey={"upload_hotel_logo"} namespace="profile" />
          </div>

          <div className="flex flex-col gap-[24px] items-start justify-start w-[100%] relative">
            {!localHotelDetailsState?.logo ? (
              <div className="w-[100%] h-[190px] bg-surface-page border-[1px] border-brand-border-muted flex flex-col justify-center items-center   rounded-[8px]">
                <div className="w-[32px] h-[32px]">
                  <img
                    src={beImagePlaceHolder}
                    className="w-[100%] h-[100%]"
                    alt=""
                  />
                </div>
                <div className="font-body font-[400] text-[14px] leading-[21px] text-fg-placeholder ">
                  <TranslateText
                    textKey={"drag_and_drop_your_logo"}
                    namespace="profile"
                  />{" "}
                </div>
                <UploadFile
                  handleImageBeforeUpload={handleImageBeforeUpload}
                  handleUpload={(item) => handleUpload(item, "logo")}
                  fileSize={10}
                >
                  <div className="font-body font-[400] text-[14px] leading-[21px] text-primary cursor-pointer">
                    <TranslateText textKey={"or_choose"} namespace="profile" />
                  </div>
                </UploadFile>
              </div>
            ) : (
              <div className="relative ">
                <img
                  src={localHotelDetailsState?.logo}
                  alt="rect"
                  id="viewer"
                  className=" w-[100%] h-[190px] border-[1px] border-[black]"
                />

                {editHotelDetails && localHotelDetailsState?.logo && (
                  <div
                    className="bg-surface w-[24px] h-[24px] rounded-[50%] flex 
                    justify-center items-center absolute top-[-10px] right-[-10px]
                     z-[10] cursor-pointer"
                    onClick={() => {
                      setLocalHotelDetailsState({
                        ...localHotelDetailsState,
                        logo: "",
                      });
                    }}
                  >
                    <IoCloseSharp className="text-[18px] text-danger " />
                  </div>
                )}
              </div>
            )}
          </div>

          {localHotelDetailsState?.coverImage ? (
            <UploadFile
              handleImageBeforeUpload={handleImageBeforeUpload}
              handleUpload={(item) => handleUpload(item, "coverImage")}
              fileSize={10}
              className="w-[100%] relative"
            >
              <div className="gap-2 border-primary border-[1px]  rounded-[8px] w-[190px] cursor-pointer flex justify-center items-center h-[48px] relative">
                <div className="bg-black flex justify-center items-center w-[24px] h-[24px] rounded-[50%]">
                  <FiEye className="text-fg-inverse text-[12px]" />
                </div>

                <div
                  className="font-body font-[500] text-[16px] leading-[24px]
                 text-success"
                >
                  <TranslateText
                    textKey={"upload_successful"}
                    namespace="profile"
                  />
                </div>

                <div
                  className="bg-surface border-primary border-[1px] rounded-[50%] 
                  w-[14px] h-[14px] flex justify-center items-center absolute 
                  top-[-8px] right-[0]"
                  onClick={(e) => {
                    let updatedLocalState = {
                      ...localHotelDetailsState,
                      coverImage: null,
                    };
                    setLocalHotelDetailsState(updatedLocalState);
                    e.stopPropagation();
                  }}
                >
                  <IoClose className="text-primary text-[10px]" />
                </div>
              </div>
            </UploadFile>
          ) : (
            <UploadFile
              handleImageBeforeUpload={handleImageBeforeUpload}
              handleUpload={(item) => handleUpload(item, "coverImage")}
              fileSize={10}
              className="w-[100%]"
            >
              <div
                className="border-primary border-[1px] font-body font-[500] text-[16px] leading-[24px] 
          text-primary rounded-[8px] w-[190px] cursor-pointer flex justify-center items-center h-[48px]"
              >
                <TranslateText
                  textKey={"upload_cover_image"}
                  namespace="profile"
                />
              </div>
            </UploadFile>
          )}

          {isCertificateUploaded ? (
            <UploadFile
              handleImageBeforeUpload={handleImageBeforeUpload}
              handleUpload={(item) =>
                handlePhotoSectionImageUpload(item, "certificate")
              }
              fileSize={10}
            >
              <div className="gap-2 border-primary border-[1px]  rounded-[8px] w-[190px] cursor-pointer flex justify-center items-center h-[48px] relative">
                <div className="bg-black flex justify-center items-center w-[24px] h-[24px] rounded-[50%]">
                  <FiEye className="text-fg-inverse text-[12px]" />
                </div>

                <div
                  className="font-body font-[500] text-[16px] leading-[24px]
                 text-success"
                >
                  <TranslateText
                    textKey={"upload_successful"}
                    namespace="profile"
                  />
                </div>

                <div
                  className="bg-surface border-primary border-[1px] rounded-[50%] 
                  w-[14px] h-[14px] flex justify-center items-center absolute 
                  top-[-8px] right-[0]"
                  onClick={(e) => {
                    let newImageState = localHotelDetailsState?.images?.filter(
                      (Obj) => Obj?.type !== "certificate"
                    );
                    let updatedLocalState = {
                      ...localHotelDetailsState,
                      images: newImageState,
                    };
                    setLocalHotelDetailsState(updatedLocalState);
                    e.stopPropagation();
                  }}
                >
                  <IoClose className="text-primary text-[10px]" />
                </div>
              </div>
            </UploadFile>
          ) : (
            <UploadFile
              handleImageBeforeUpload={handleImageBeforeUpload}
              handleUpload={(item) =>
                handlePhotoSectionImageUpload(item, "certificate")
              }
              fileSize={10}
            >
              <div
                className="border-primary border-[1px] font-body font-[500] text-[16px] leading-[24px] 
          text-primary rounded-[8px] w-[190px] flex justify-center items-center h-[48px] cursor-pointer"
              >
                <TranslateText
                  textKey={"reward_certificate"}
                  namespace="profile"
                />
              </div>
            </UploadFile>
          )}
        </div>
      </main>

      <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />

      <div className="flex flex-col gap-[24px] ">
        {" "}
        <PhotosSection
          imageTitle={"hotelImages"}
          title={"Upload photos of your hotel"}
          imageArray={localHotelDetailsState?.images?.filter(
            (Obj) => Obj?.type === "hotelImages"
          )}
          handleUpload={handlePhotoSectionImageUpload}
          removeImage={removeImage}
        />
        <div className="w-[100%] border-[0.5px] border-neutral-200 my-[32px]" />
        <PhotosSection
          imageTitle={"brandsLogo"}
          imageArray={localHotelDetailsState?.images?.filter(
            (Obj) => Obj?.type === "brandsLogo"
          )}
          title={"Upload logo of the brands associated with you"}
          handleUpload={handlePhotoSectionImageUpload}
          removeImage={removeImage}
        />
      </div>

      <div className="font-body font-[500] text-[24px] leading-[30.24px] text-fg bg-brand-border-muted py-[8px] flex justify-center items-center w-[100%] mt-[64px] mb-[24px]">
        <TranslateText textKey={"preview"} namespace="profile" />
      </div>

      <div className="previewSection">
        <Preview localHotelDetailsState={localHotelDetailsState} />
      </div>
    </div>
  );
};

export default BEHotelDetails;
